module.exports = "/assets/decorator-korw.jpg?tjXTBYj";